module.exports = __webpack_public_path__ + "static/media/marilu-45.73d1fe67.png";